import React from 'react'
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import Form from "../../../components/form/Form";
import DashboardPanel from "./DashboardPanel";
import Calendar, { WeekInputComponent } from './Calendar';
import Opportunity from "../../../models/Opportunity";
import DashboardPreferences from '../../talent-preferences/components/DashboardPreferences';
import { Modal } from 'antd';
import ResetAvailabilityModal from "./ResetAvailabilityModal";


export default class AvailabilityPanel extends DashboardPanel {

    // static header = 'talent.dashboard.availability_title';
    static header = 'Availability and Work Status';

    static is_active = true;
    static inactiveMessage = 'Use our availability calendar to manage when you’re open for work.';

    static LastUpdatedMethod = 'lastUpdatedWorkStatus';
    static columns = 'auto'
    static colClass = ''

    static columnProps = {
        xl: 6,
        lg: 7,
        md: 7,
        sm: 12,
        xs: 12
    }
    static columnOrdering = {
        xl: 2,
        lg: 2,
        md: 2,
        sm: 3,
        xs: 3
    }

    constructor(props, context) {
        super(props, context);

        this.form = React.createRef();
        this.state = {
            auth: props.user || context?.auth || {},
            isEditing: false,
            isLoading: false,
            showResetModal: false,
            isExpringSoonOpen: true,
        }
    }


    isDisabled() {
        return false
        // return !this.hasCompletedProfile()
    }

    isAvailabilityExpired() {
        const { talent_availability_confirmed_at } = this.props.user || this.context.auth;

        if (!talent_availability_confirmed_at) {
            return true;
        }

        return !(this.props.user || this.context.auth)?.hasConfirmedAvailabilityForOpportunities?.()
    }

    isAvailabilityExpiring() {
        const { talent_availability_confirmed_at } = this.props.user || this.context.auth;

        if (!talent_availability_confirmed_at) {
            return false;
        }

        const expirationDate = TB.moment(talent_availability_confirmed_at).add(1, 'month');
        const today = TB.moment();
        const daysUntilExpiry = expirationDate.diff(today, 'days');

        return daysUntilExpiry <= 5 && daysUntilExpiry >= 0;
    }

    getDaysUntilExpiry() {
        const expirationDate = this.getExpirationDate();
        if (!expirationDate) return null;
        return expirationDate.diff(TB.moment(), 'days');
    }

    getExpirationMessage() {
        const { talent_availability_confirmed_at } = this.props.user || this.context.auth;

        if (!talent_availability_confirmed_at) {
            return 'Your availability has not been confirmed';
        }

        const confirmedDate = TB.moment(talent_availability_confirmed_at);
        const now = TB.moment();

        return `Your availability was last confirmed ${confirmedDate.from(now)}`;
    }

    getExpirationDate() {
        const { talent_availability_confirmed_at } = this.props.user || this.context.auth;

        if (!talent_availability_confirmed_at) {
            return null;
        }

        return TB.moment(talent_availability_confirmed_at).add(1, 'month');
    }

    mapModel(model) {
        let auth = { ...this.state.auth };

        let params = {
            work_schedule_weeks: {
                ...auth.work_schedule_weeks
            },
            available_hours_per_week: model.available_hours_per_week
        }
        TB.map(model, (value, key) => {
            params = TB.set(params, key, value);
        });

        return params;
    }

    async onSubmit(model) {
        let params = this.mapModel(model);
        params.work_schedule_weeks = TB.map(params.work_schedule_weeks, (hours, week) => {
            return {
                started_at: week,
                available_hours: parseInt(hours) || 0
            }
        });
        let updated = await this.talentUpdate(params);
        if (updated) {
            return TB.sysAlert('talent.availability_updated_success')
        }
    }

    async toggleAvailability(checked) {
        let is_available = checked ? 1 : 0;

        if (!is_available) {
            let confirm = await TB.sysAlert('talent.turn_off_availability_warning');
            if (!confirm) return;
        }

        let updated = await this.talentUpdate({ is_available });

        if (!updated) {
            return;
        }

        if (is_available) {
            return await TB.sysAlert('talent.availability_turned_on');
        } else {
            Opportunity.clearCache();

            return await TB.sysAlert('talent.availability_turned_off');
        }
    }

    async talentUpdate(params) {
        if (this.state.isLoading) return false;

        await this.setState({ isLoading: true })

        let auth = await TB.auth().talentUpdate(params);

        if (auth) {

            await this.setState({
                auth: TB.pick(auth, [
                    'work_schedule_weeks',
                    'available_hours_per_week',
                    'is_available',
                    'talent_commitment_level',
                    // 'has_contract_to_hire_interest',
                    'has_full_time_employment_interest',
                    'talent_availability_confirmed_at',
                ]),
            })
        }

        await TB.wait(250);

        await this.setState({ isLoading: false })

        return auth;
    }

    async syncAllWeeksToDefault() {
        let {
            available_hours_per_week,
            is_available,
            work_schedule_weeks
        } = this.state.auth;

        let auth = {
            available_hours_per_week,
            is_available,
            work_schedule_weeks: {}
        };

        for (let [week, hours] of Object.entries(work_schedule_weeks)) {
            auth.work_schedule_weeks[week] = available_hours_per_week
        }

        return this.setState({ auth })
    }

    resetAvailability() {
        return this.setState({
            isEditing: false,
            auth: TB.pick({ ...(this.context?.auth || {}) }, [
                'is_available',
                'work_schedule_weeks',
                'available_hours_per_week',
                'talent_commitment_level',
                'has_contract_to_hire_interest',
                'has_full_time_employment_interest',
                'talent_availability_confirmed_at',
            ])
        })
    }

    renderPanel() {

        if (this.isDisabled()) {
            return this.renderDisabled()
        }

        if (this.isInactive()) {
            return this.renderInactive()
        }


        return (
            <div className="talent-dashboard-panel justify-start">
                <Form
                    ref={this.form}
                    className="default-form availability-form"
                    submitButton={false}
                    background={'none'}
                    model={this.state.auth}
                    fields={[]}
                    onSubmit={this.onSubmit.bind(this)}
                    onChange={model => {

                        let auth = this.mapModel(model);

                        this.setState({ auth: { ...this.state.auth, ...auth } })
                    }}>

                    {this.renderPanelHeader()}

                    {this.renderAvailabilityToggle()}

                    {this.renderPanelContent()}

                    {!this.isAvailabilityExpired() && this.renderPanelFooter()}

                </Form>

            </div>
        )
    }

    renderAvailabilityToggle() {
        let { readOnly, user } = this.props;
        let { auth, isLoading } = this.state;

        return (
            <>
                <DashboardPreferences
                    onChange={model => {
                        console.log('availabilitypanelchange', model)
                        return this.talentUpdate(model)
                    }}
                    isDisabled={isLoading || readOnly}
                />

                <div className="flex justify-end pb-2">
                    <Link
                        to="/talent/work-preferences"
                        className="btn btn-link"
                    >
                        Edit work preferences
                    </Link>
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    className="btn btn-primary"*/}
                    {/*    disabled={isLoading || readOnly}*/}
                    {/*    onClick={() => {*/}
                    {/*        try {*/}
                    {/*            this.talentUpdate(*/}
                    {/*                TB.pick(auth, [*/}
                    {/*                    'is_available',*/}
                    {/*                    'talent_commitment_level',*/}
                    {/*                    'has_contract_to_hire_interest',*/}
                    {/*                ])*/}
                    {/*            )*/}
                    {/*            return TB.sysAlert('talent.availability_updated_success')*/}

                    {/*        } catch (error) {*/}
                    {/*            console.log(error, 'error')*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Save Preferences*/}
                    {/*</button >*/}
                </div>

                {/* <div className="form-group availability-toggle">
                    <label htmlFor="availability-toggle">
                        <span>
                            {
                                user ? `Active on the ${laravel.platform_name} Marketplace`
                                    : `I want to be active on the ${laravel.platform_name} Marketplace`
                            }
                        </span>

                        <Switch
                            height={21}
                            width={48}
                            style={{ transform: [{ scaleX: .7 }, { scaleY: .7 }] }}
                            checked={!!auth.is_available}
                            onChange={this.toggleAvailability.bind(this)}
                            onColor={TB.config('color.light_green')}
                            offColor={'#C2CFE0'}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            activeBoxShadow={'0 0 1px 2px ' + TB.config('color.light_purple')}
                            className="react-switch"
                            id="availability-toggle"
                            disabled={isLoading || readOnly}
                        />
                    </label>
                </div> */}
            </>

        )
    }

    renderPanelContent() {
        const isExpired = this.isAvailabilityExpired();
        const oneMonthFromNow = TB.moment().add(1, 'month').format('MMMM D, YYYY');
        const expirationDate = this.getExpirationDate();
        const isExpiring = this.isAvailabilityExpiring();

        return (
            <>
                {!isExpired && expirationDate && (
                    <div className="flex items-center justify-center px-3 border border-bottom-0" style={{
                        fontSize: '11px',
                        backgroundColor: '#f5f5f5',
                        borderColor: '#ddd',
                        paddingTop: '6px',
                        paddingBottom: '6px',
                        borderTopLeftRadius: '6px',
                        borderTopRightRadius: '6px'
                    }}>
                        <div className="text-gray-800 text-center">
                            Availability for work assignments confirmed until: <span className="font-semibold">{expirationDate.format('MMM D, YYYY')}</span>. Expires {expirationDate.fromNow()}
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-dark ml-3"
                                style={{ fontSize: '10px', padding: '2px 8px' }}
                                disabled={this.state.isLoading}
                                onClick={() => this.props.onResetAvailability()}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                )}

                <div className="availability-calendar relative">
                    <div className={TB.mapClass("flex-1", {
                        'opacity-40 pointer-events-none': isExpired,
                    })}>
                        <Calendar
                            isLoading={this.state.isLoading}
                            readOnly={this.props.readOnly}
                            isEditing={this.state.isEditing && !this.props.readOnly}
                            availableHoursPerWeek={this.state.auth.available_hours_per_week || ''}
                            workScheduleWeeks={this.state.auth.work_schedule_weeks || {}}
                        />
                    </div>

                    {(isExpired || (isExpiring && this.state.isExpringSoonOpen)) && (() => {
                        const daysLeft = this.getDaysUntilExpiry();
                        const title = isExpired ? 'Availability Expired' : 'Availability Expiring Soon';
                        const message = isExpired
                            ? this.getExpirationMessage()
                            : daysLeft === 0
                                ? 'Your availability expires today'
                                : 'Your availability expires soon';
                                // : `Your availability expires in ${daysLeft} day${daysLeft !== 1 ? 's' : ''}`;

                        return (
                            <>
                                <div className="absolute inset-0 bg-black bg-opacity-30 z-10" />
                                <div className="absolute inset-0 flex items-center justify-center p-4 z-20">
                                    <div className="bg-white rounded-lg shadow-lg p-6 max-w-md text-center relative">
                                        {!isExpired && (
                                            <button type="button" className="absolute top-2 right-2" onClick={() => this.setState({ isExpringSoonOpen: false })}>
                                                <X className="h-3 w-3" />
                                            </button>
                                        )}
                                        <div className="flex items-center justify-center mb-3">
                                            <svg
                                                className="w-5 h-5 mr-2"
                                                fill={TB.config('color.danger')}
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                            <h3 className="text-base font-semibold text-gray-800">
                                                {title}
                                            </h3>
                                        </div>
                                        <p className="text-xs text-gray-600 mb-2">
                                            {message}
                                        </p>
                                        {!this.props.readOnly && (
                                            <>
                                                <p className="text-xs text-gray-700 mb-4">
                                                    By confirming your availability, clients are more likely to reach out for current job postings and opportunities.
                                                </p>
                                                <button
                                                    type="button"
                                                    className="btn w-full text-xs btn-dark"
                                                    disabled={this.state.isLoading}
                                                    onClick={() => this.props.onResetAvailability()}
                                                >
                                                    I'm ready for opportunities until {oneMonthFromNow}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        );
                    })()}
                </div>
            </>
        )
    }

    renderPanelFooter() {
        let { readOnly } = this.props;
        let { isEditing, auth, isLoading } = this.state;
        return (
            <div className="availability-footer">
                <div className="edit-availability-default">

                    <div className="input-container">
                        <span>
                            Default open hours per week
                        </span>
                        <WeekInputComponent
                            name={'available_hours_per_week'}
                            value={auth.available_hours_per_week}
                            disabled={!isEditing || readOnly}
                        />
                    </div>


                    {isEditing && !readOnly && (
                        <button
                            type="button"
                            onClick={async () => {
                                let confirm = await TB.alert(
                                    'alert',
                                    'Reset All Weeks?',
                                    "Are you sure you want to set all weeks to your default open hours per week?",
                                    [
                                        {
                                            title: 'Yes, continue'
                                        },
                                        {
                                            title: 'Cancel'
                                        }
                                    ]
                                );
                                if (confirm) return this.syncAllWeeksToDefault();
                            }}
                            disabled={isLoading}
                            className="btn btn-link-primary">
                            Set all weeks to this default
                        </button>
                    )}

                </div>

                {!this.isDisabled() && !readOnly && !this.isInactive() && (
                    <div className="edit-availability-button">

                        <button type={isEditing ? 'button' : 'submit'}
                            className="btn btn-primary" disabled={isLoading}
                            onClick={() => this.setState({ isEditing: !isEditing })}>

                            {isEditing ? 'Save Changes' : 'Click to edit open hours'}

                        </button>

                        {isEditing && (
                            <button type="button" className="btn btn-light ml-3"
                                disabled={isLoading} onClick={this.resetAvailability.bind(this)}>
                                Cancel
                            </button>
                        )}
                    </div>
                )}
            </div>
        )
    }
}